const combineBatches = (batches = []) =>
  batches.reduce(
    (currentBatch, batch) => ({
      ...currentBatch,
      ...Object.fromEntries(
        Object.entries(batch).map(([elementId, attributes]) => [
          elementId,
          { ...currentBatch[elementId], ...attributes },
        ])
      ),
    }),
    {}
  );

export default combineBatches;
